import { Badge, HomeRepairService, LockPerson, ManageHistoryRounded, PriceChange } from "@mui/icons-material";
import { guides } from "../../guides/Guide";
import Logo from "../../icons/Logo";
import { hasKey } from "../../models/Identity";
import { IAppMenu } from "../../nav/AppRoute";
import TenantView from "./TenantForm";
import EmployeeView from "./employees";
import PeriodicServiceView from "./periodicService";
import PositionView from "./positions";
import ServiceView from "./service";
import TariffView from "./tariff";

guides.projectMenu = [
    {
        target: '#positions-menu',
        placementBeacon: 'right',
        placement: 'right',
        title: 'Должности',
        content: <><b>Должности</b> разделяют права <b>Сотрудников</b> в ЖК с помощью ключей доступа.
            <p>Например, для доступа к <b>Клиентам</b>, <b>Группам</b> и Управлению ЖК</p>
            <p>При создании нового ЖК по умолчанию создаются преднастроенные <b>Должности</b>
                <ul>
                    <li><i>Руководитель</i> - с полным доступом к всем функциям</li>
                    <li><i>Администратор</i> - с доступами к ведению <b>Клиентов</b> и <b>Групп</b></li>
                    <li><i>Преподователь</i> - с доступом к ведению закрепленными за ним <b>Групп</b></li>
                </ul>
            </p>
        </>,
    },
].map(x => ({
    ...x,
    placementBeacon: 'right',
    placement: 'right',
}));

const projectMenu: IAppMenu = [
    {
        path: "",
        tenanted: true,
        title: 'Основное',
        icon: <Logo />,
        element: () => <TenantView idRoute="subpage" />,
    },
    {
        id: 'positions-menu',
        path: "positions/*",
        icon: <LockPerson />,
        title: 'Должности',
        hidden: () => !hasKey('Position'),
        element: () => <PositionView />,
    },
    {
        id: 'emploees-menu',
        path: "emploees/*",
        icon: <Badge />,
        title: 'Сотрудники',
        hidden: () => !hasKey('Employee'),
        element: () => <EmployeeView />,
    },
    {
        id: 'tariff-menu',
        path: "tariff/*",
        icon: <PriceChange />,
        title: 'Тарифы',
        hidden: () => !hasKey('Tariff'),
        element: () => <TariffView />,
    },
    {
        id: 'service-menu',
        path: "service/*",
        icon: <HomeRepairService />,
        title: 'Услуги',
        hidden: () => !hasKey('Service'),
        element: () => <ServiceView />,
    },
    {
        id: 'periodicService-menu',
        path: "periodicService/*",
        icon: <ManageHistoryRounded />,
        title: 'Регулярные услуги',
        hidden: () => !hasKey('PeriodicService'),
        element: () => <PeriodicServiceView />,
    }
];

projectMenu.forEach(x => x && (x.path = 'project/' + x.path));

export default projectMenu;